// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ICombineHsaFileResponseDto
 */
export interface ICombineHsaFileResponseDto {
    /**
     * 
     * @type {string}
     * @memberof ICombineHsaFileResponseDto
     */
    file_url?: string;
    /**
     * 
     * @type {string}
     * @memberof ICombineHsaFileResponseDto
     */
    s3key?: string;
}

/**
 * Check if a given object implements the ICombineHsaFileResponseDto interface.
 */
export function instanceOfICombineHsaFileResponseDto(value: object): value is ICombineHsaFileResponseDto {
    return true;
}

export function ICombineHsaFileResponseDtoFromJSON(json: any): ICombineHsaFileResponseDto {
    return ICombineHsaFileResponseDtoFromJSONTyped(json, false);
}

export function ICombineHsaFileResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICombineHsaFileResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'file_url': json['file_url'] == null ? undefined : json['file_url'],
        's3key': json['s3key'] == null ? undefined : json['s3key'],
    };
}

export function ICombineHsaFileResponseDtoToJSON(json: any): ICombineHsaFileResponseDto {
    return ICombineHsaFileResponseDtoToJSONTyped(json, false);
}

export function ICombineHsaFileResponseDtoToJSONTyped(value?: ICombineHsaFileResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'file_url': value['file_url'],
        's3key': value['s3key'],
    };
}

